import { fcaFastApi, fcaGateWay, fcaReportGateway } from "../../services/authorizationService";
import * as serviceEndpoints from "../../config/serviceEndPoints";
import { isEnabled } from "../../services/featureFlags";

export const getAllRecommendations = (params, id) =>
    fcaGateWay.get(`${serviceEndpoints.recommendationEndPoints.getAllRecommendationsById}/${id}/recommendations`, { params });
export const getAllRecommendationsRegion = params =>
    (isEnabled("migrate_recommendations_crud") ? fcaFastApi : fcaGateWay).get(
        `${serviceEndpoints.recommendationEndPoints.getAllRecommendationsByIdRegion}`,
        { params }
    );
export const addRecommendation = params =>
    (isEnabled("migrate_recommendations_crud") ? fcaFastApi : fcaGateWay).post(serviceEndpoints.recommendationEndPoints.addRecommendation, params);
export const updateRecommendation = (params, id) =>
    (isEnabled("migrate_recommendations_crud") ? fcaFastApi : fcaGateWay).patch(
        `${serviceEndpoints.recommendationEndPoints.updateRecommendation}/${id}`,
        params
    );
export const deleteRecommendation = (id, param = false) =>
    param
        ? (isEnabled("migrate_recommendations_crud") ? fcaFastApi : fcaGateWay).delete(
              `${serviceEndpoints.recommendationEndPoints.deleteRecommendation}/${id}?hard_delete=true`
          )
        : (isEnabled("migrate_recommendations_crud") ? fcaFastApi : fcaGateWay).delete(
              `${serviceEndpoints.recommendationEndPoints.deleteRecommendation}/${id}`
          );
export const getRegionsBasedOnClient = id => fcaGateWay.get(`${serviceEndpoints.recommendationEndPoints.getRegionsBasedOnClient}/${id}/regions`);
export const getBuildingsBasedOnSite = id =>
    fcaGateWay.get(`${serviceEndpoints.recommendationEndPoints.getBuildingsBasedOnSite}/${id}/buildings_dropdown`);
export const getFloorBasedOnBuilding = id =>
    fcaGateWay.get(`${serviceEndpoints.recommendationEndPoints.getFloorBasedOnBuilding}/${id}/floors_dropdown`);
export const getAdditionBasedOnBuilding = id =>
    fcaGateWay.get(`${serviceEndpoints.recommendationEndPoints.getAdditionBasedOnBuilding}/${id}/additions_dropdown`);
export const getAllConsultancyUsers = () => fcaGateWay.get(`${serviceEndpoints.recommendationEndPoints.getAllConsultancyUsers}`);
export const getAllClients = () => fcaGateWay.get(`${serviceEndpoints.recommendationEndPoints.getAllClients}`);
export const getRecommendationById = id =>
    (isEnabled("migrate_recommendations_crud") ? fcaFastApi : fcaGateWay).get(
        `${serviceEndpoints.recommendationEndPoints.getRecommendationById}/${id}`
    );
export const uploadImage = (imageData, id) => fcaGateWay.post(`${serviceEndpoints.recommendationEndPoints.uploadImage}/${id}/upload`, imageData);
export const getAllImages = (id, params) => fcaGateWay.get(`${serviceEndpoints.recommendationEndPoints.getAllImages}/${id}/images`, { params });
export const deleteImages = id => {
    if (Array.isArray(id)) {
        return fcaGateWay.delete(`${serviceEndpoints.recommendationEndPoints.deleteImages}/remove_multiple_images`, { data: { image_ids: id } });
    }
    return fcaGateWay.delete(`${serviceEndpoints.recommendationEndPoints.deleteImages}/${id}/remove_image`);
};

export const updateImageComment = imageData =>
    fcaGateWay.patch(`${serviceEndpoints.recommendationEndPoints.updateImageComment}/${imageData.id}/update_image`, imageData);
export const updateRecommendationImageSort = (id, params) =>
    fcaGateWay.patch(`${serviceEndpoints.recommendationEndPoints.updateRecommendationImageSort}/${id}/image_sort`, params);
export const getSystemBasedOnProject = (id, tradeId, params, source) =>
    source === "global"
        ? fcaFastApi.get(`${serviceEndpoints.projectEndPoints.getGlobalProjectSettingsData}/systems/systems_dropdown`, { params })
        : fcaGateWay.get(
              `${serviceEndpoints.recommendationEndPoints.getSystemBasedOnProject}/${id}/systems_dropdown${tradeId ? `?trade_id=${tradeId}` : ""}`
          );
export const getTradeBasedOnProject = (id, params, source) =>
    source === "global"
        ? fcaFastApi.get(`${serviceEndpoints.projectEndPoints.getGlobalProjectSettingsData}/trades/trades_dropdown`, { params })
        : fcaGateWay.get(`${serviceEndpoints.recommendationEndPoints.getSystemBasedOnProject}/${id}/trades_dropdown`);
export const getSubSystemBasedOnProject = (id, systemId, tradeId, params, source) =>
    source === "global"
        ? fcaFastApi.get(`${serviceEndpoints.projectEndPoints.getGlobalProjectSettingsData}/sub_systems/dropdown`, { params })
        : fcaGateWay.get(
              `${serviceEndpoints.recommendationEndPoints.getSubSystemBasedOnProject}/${id}/sub_systems_dropdown${
                  systemId ? `?system_id=${systemId}` : tradeId ? `?trade_id=${tradeId}` : ""
              }`
          );

export const getCategoryBasedOnProject = (id, params, source) =>
    source === "global"
        ? fcaFastApi.get(`${serviceEndpoints.projectEndPoints.getGlobalProjectSettingsData}/categories/dropdown`, { params })
        : fcaFastApi.get(`${serviceEndpoints.recommendationEndPoints.getCategoryBasedOnProject}/${id}/categories_dropdown`);

export const getCapitalTypeBasedOnProject = id =>
    fcaGateWay.get(`${serviceEndpoints.recommendationEndPoints.getCapitalTypeBasedOnProject}/${id}/capital_types_dropdown`);

export const getListForCommonFilter = params =>
    (isEnabled("migrate_recommendations_crud") ? fcaFastApi : fcaGateWay).get(
        `${serviceEndpoints.recommendationEndPoints.getListForCommonFilter}/get_list`,
        {
            params
        }
    );
export const getCostYearByProject = (projectId, siteId) =>
    fcaGateWay.get(`${serviceEndpoints.recommendationEndPoints.getCostYearByProject}/${projectId}/maintenance_year_limit?site_id=${siteId}`);

export const getFundingSourceByProject = (id, params, source) =>
    source === "global"
        ? fcaFastApi.get(`${serviceEndpoints.projectEndPoints.getGlobalProjectSettingsData}/funding_sources/dropdown`, { params })
        : fcaGateWay.get(`${serviceEndpoints.recommendationEndPoints.getFundingSourceByProject}/${id}/funding_sources_dropdown`);

export const getSpaceType = params => fcaFastApi.get(serviceEndpoints.recommendationEndPoints.getSpaceType, { params });
export const getResponsibilityByProject = (id, params, source) =>
    source === "global"
        ? fcaFastApi.get(`${serviceEndpoints.projectEndPoints.getGlobalProjectSettingsData}/responsibilities/dropdown`, { params })
        : fcaGateWay.get(`${serviceEndpoints.recommendationEndPoints.getFundingSourceByProject}/${id}/responsibilities_dropdown`);
export const getRecommendationAcceptableVerbsByProject = (id, params, source) =>
    source === "global"
        ? fcaFastApi.get(`${serviceEndpoints.projectEndPoints.getGlobalProjectSettingsData}/recommendation_acceptable_verbs/dropdown`, { params })
        : fcaFastApi.get(`${serviceEndpoints.recommendationEndPoints.getFundingSourceByProject}/${id}/recommendation_acceptable_verbs_dropdown`);
// getFundingSourceByProject
export const updateMaintenanceYearCutPaste = params =>
    fcaGateWay.patch(`${serviceEndpoints.recommendationEndPoints.updateMaintenanceYearCutPaste}/move_year_values`, params);
export const exportRecommendations = params =>
    fcaReportGateway.post(`${serviceEndpoints.recommendationEndPoints.exportRecommendations}`, params, {
        method: "POST",
        responseType: "blob"
    });
export const exportRecommendationByRegion = params =>
    fcaGateWay.get(`${serviceEndpoints.recommendationEndPoints.exportRecommendations}/export_xl`, { method: "GET", responseType: "blob", params });
export const exportRecommendationBySite = params =>
    fcaGateWay.get(`${serviceEndpoints.recommendationEndPoints.exportRecommendations}/export_xl`, { method: "GET", responseType: "blob", params });
export const exportRecommendationByBuilding = params =>
    fcaGateWay.get(`${serviceEndpoints.recommendationEndPoints.exportRecommendations}/export_xl`, { method: "GET", responseType: "blob", params });
export const exportAllTrades = params =>
    fcaGateWay.get(`${serviceEndpoints.recommendationEndPoints.exportAllTrades}/export_all_trades`, { method: "GET", responseType: "blob", params });

export const recoverRecommendation = id =>
    (isEnabled("migrate_recommendations_crud") ? fcaFastApi : fcaGateWay).patch(
        `${serviceEndpoints.recommendationEndPoints.recoverRecommendation}/${id}/restore`
    );
export const getConditionBasedOnProject = (id, params, source) =>
    source === "global"
        ? fcaFastApi.get(`${serviceEndpoints.projectEndPoints.getGlobalProjectSettingsData}/asset_conditions/dropdown`, { params })
        : fcaGateWay.get(`${serviceEndpoints.recommendationEndPoints.getSystemBasedOnProject}/${id}/asset_conditions_dropdown`);
export const getAllRecommendationLogs = (id, params) => {
    return (isEnabled("migrate_recommendations_crud") ? fcaFastApi : fcaGateWay).get(
        `${serviceEndpoints.recommendationEndPoints.getAllRecommendationLogs}/${id}/logs`,
        { params }
    );
};
export const restoreRecommendationLog = id => fcaGateWay.patch(`${serviceEndpoints.recommendationEndPoints.restoreRecommendationLog}/${id}/restore`);
export const deleteRecommendationLog = id => fcaGateWay.delete(`${serviceEndpoints.recommendationEndPoints.deleteRecommendationLog}/${id}`);

export const getReportNoteTemplates = (params, dynamicUrl) =>
    fcaGateWay.get(`${serviceEndpoints.recommendationEndPoints.getReportNoteTemplates}${dynamicUrl}`, { params });
export const addUserActivityLog = text => fcaGateWay.post(`${serviceEndpoints.logEndPoints.addLog}`, text);
export const getInitiativeDropdown = params => fcaGateWay.get(`${serviceEndpoints.recommendationEndPoints.getInitiativeDropdown}`, { params });

export const downloadPdfReport = params => fcaReportGateway.get(`${serviceEndpoints.recommendationEndPoints.downloadPdfReport}`, { params });

export const assignImagesToRecom = (data, id) =>
    fcaGateWay.post(`${serviceEndpoints.recommendationEndPoints.assignImagesToRecom}/${id}/assign_master_images`, data);
export const unAssignImage = params =>
    fcaGateWay.delete(`${serviceEndpoints.recommendationEndPoints.unAssignImage}/${params.id}/remove_from_recommendations`, { params });
//budgetpriority
export const updateBudgetPriority = (params, id) =>
    fcaGateWay.patch(`${serviceEndpoints.recommendationEndPoints.updateBudgetPriority}/${id}/update_budget_priority`, params);
export const getAllBudgetPriorityRecommendations = params =>
    (isEnabled("migrate_dashboard_reads") ? fcaFastApi : fcaGateWay).get(
        `${serviceEndpoints.recommendationEndPoints.getAllBudgetPriorityRecommendations}`,
        { params }
    );

export const exportBudgetPriorityRecommendations = params =>
    fcaGateWay.get(`${serviceEndpoints.recommendationEndPoints.exportBudgetPriority}`, { method: "GET", responseType: "blob", params });

export const getListForBudgetPriorityFilter = params =>
    (isEnabled("migrate_dashboard_reads") ? fcaFastApi : fcaGateWay).get(
        `${serviceEndpoints.recommendationEndPoints.getListForBudgetPriorityFilter}`,
        {
            params
        }
    );
export const getRecommendationTemplates = (params, dynamicUrl) =>
    fcaGateWay.get(`${serviceEndpoints.recommendationEndPoints.getRecommendationTemplates}${dynamicUrl}`, { params });
export const getUserDefaultTrade = id => fcaGateWay.get(`${serviceEndpoints.recommendationEndPoints.getUserDefaultTrade}/${id}/trades/user_trade`);
export const updateMultipleRecommendations = (data, ids, options = {}) => {
    const { is_cr: _, ...recommendationData } = data || {};
    return fcaGateWay.patch(`${serviceEndpoints.recommendationEndPoints.updateMultipleRecommendations}`, {
        recommendation: { ...recommendationData },
        recommendation_ids: ids,
        ...(options.is_cr && { is_cr: true })
    });
};
export const updateFMP = (params, id) => fcaGateWay.patch(`${serviceEndpoints.recommendationEndPoints.updateFMP}/${id}/update_fmp`, params);
export const getRecommendationCommonDataByIds = params =>
    fcaGateWay.post(`${serviceEndpoints.recommendationEndPoints.getRecommendationCommonDataByIds}`, params);
export const getAllRecommendationIds = params => fcaGateWay.get(`${serviceEndpoints.recommendationEndPoints.getAllRecommendationIds}`, { params });
export const getPriorityElementDropDownData = projectId =>
    fcaGateWay.get(`${serviceEndpoints.recommendationEndPoints.getPriorityElementDropDownData}/${projectId}/priority_elements_dropdown`);
// update IR
export const updateIR = (params, id) =>
    fcaGateWay.patch(`${serviceEndpoints.recommendationEndPoints.updateIR}/${id}/update_infrastructure_request`, params);
export const updateRL = (params, id) => fcaGateWay.patch(`${serviceEndpoints.recommendationEndPoints.updateIR}/${id}/update_red_line`, params);
export const updateContinuousFCA = (params, id) =>
    fcaGateWay.patch(`${serviceEndpoints.recommendationEndPoints.updateIR}/${id}/update_continuous_fca`, params);
//reportpdfexport
export const exportReportPdf = (params, exportType) =>
    fcaReportGateway.post(`${serviceEndpoints.recommendationEndPoints[exportType === "word" ? "getWordforReport" : "getPdfforReport"]}`, params, {
        method: "POST",
        responseType: "blob"
    });

export const exportSelectedRecomWord = params =>
    fcaReportGateway.post(`${serviceEndpoints.recommendationEndPoints.exportSelectedRecomWord}`, params, { method: "POST", responseType: "blob" });

export const exportSelectedRecomPDF = params =>
    fcaReportGateway.post(`${serviceEndpoints.recommendationEndPoints.exportSelectedRecomPDF}`, params, { method: "POST", responseType: "blob" });
export const getCriticalityDropDownData = projectId =>
    fcaGateWay.get(`${serviceEndpoints.recommendationEndPoints.getCriticalityDropDownData}/${projectId}/criticalities_dropdown`);
export const exportToWord = params => fcaReportGateway.post(`${serviceEndpoints.recommendationEndPoints.exportToWord}`, params);
export const getCapitalTypeDropDownData = (projectId, params, source) =>
    source === "global"
        ? fcaFastApi.get(`${serviceEndpoints.projectEndPoints.getGlobalProjectSettingsData}/capital_types/dropdown`, { params })
        : fcaGateWay.get(`${serviceEndpoints.recommendationEndPoints.getCapitalTypeDropDownData}/${projectId}/capital_types_dropdown`);
export const getImportViewTableModal = (params, source) => {
    if (source === "asset_export_history") {
        return fcaReportGateway.get(`${serviceEndpoints.assetEndPoints.exportHistory}`, { params });
    }
    if (source === "files") {
        return fcaFastApi.get(`${serviceEndpoints.projectEndPoints.getFiles}`, { params });
    }
    return fcaReportGateway.get(`${serviceEndpoints.recommendationEndPoints.getImportTableWord}`, { params });
};
export const updateNoteImportViewTableModal = (params, id) =>
    fcaReportGateway.patch(`${serviceEndpoints.recommendationEndPoints.updateNoteImportTableWord}${id}/`, { export_notes: params });
export const getExportExcelFromExport = (params, source) => {
    if (source === "asset_export_history") {
        return fcaReportGateway.get(`${serviceEndpoints.assetEndPoints.exportHistoryExcelExport}`, { responseType: "blob", method: "GET", params });
    }
    return fcaReportGateway.get(`${serviceEndpoints.recommendationEndPoints.getExportExcelFromExport}`, {
        responseType: "blob",
        method: "GET",
        params
    });
};
export const exportToExcelFile = params =>
    fcaReportGateway.post(`${serviceEndpoints.recommendationEndPoints.exportToExcelFile}`, params, { method: "POST", responseType: "blob" });
export const exportCrossWalkExcel = params =>
    fcaReportGateway.post(`${serviceEndpoints.recommendationEndPoints.exportCrossWalkExcel}`, params, { method: "POST", responseType: "blob" });

// for export settings
export const getExportRecom = params => fcaReportGateway.get(`${serviceEndpoints.recommendationEndPoints.getExportColumns}`, { params });
export const getExportPropertyDropdown = params =>
    fcaReportGateway.get(`${serviceEndpoints.recommendationEndPoints.getExportPropertyDropdown}`, { params });
export const postExportRecom = (params, file) =>
    fcaReportGateway.post(`${serviceEndpoints.recommendationEndPoints.postExportColumns}`, params, { method: "POST", responseType: "blob" });
export const lockRecommendation = (id, params) =>
    fcaGateWay.patch(`${serviceEndpoints.recommendationEndPoints.lockRecommendation}/${id}/lock`, params);
export const getDynamicFields = params => fcaGateWay.get(`${serviceEndpoints.recommendationEndPoints.getDynamicFields}`, { params });
export const getReferenceDynamicFieldsByScope = params =>
    fcaGateWay.get(`${serviceEndpoints.recommendationEndPoints.getReferenceDynamicFieldsByScope}`, { params });
export const createQaQcIssue = params => {
    if (params?.recommendation_ids) {
        return fcaGateWay.post(`${serviceEndpoints.recommendationEndPoints.addRecommendationReviews}/bulk_create`, params);
    }
    return fcaGateWay.post(`${serviceEndpoints.recommendationEndPoints.addRecommendationReviews}`, params);
};
export const getAllRecommendationReviews = params =>
    (isEnabled("migrate_recommendations_crud") ? fcaFastApi : fcaGateWay).get(
        `${serviceEndpoints.recommendationEndPoints.getAllRecommendationReviews}`,
        { params }
    );
export const updateRecommendationReview = (id, params) =>
    fcaGateWay.put(`${serviceEndpoints.recommendationEndPoints.updateRecommendationReviewTitle}/${id}`, params);
export const updateRecommendationReviewStatusReviewer = (id, params) =>
    (isEnabled("migrate_recommendations_crud") ? fcaFastApi : fcaGateWay).post(
        `${serviceEndpoints.recommendationEndPoints.updateRecommendationReviewStatus}/${id}/reviewer_update`,
        params
    );
export const updateRecommendationReviewStatusUser = (id, params) =>
    (isEnabled("migrate_recommendations_crud") ? fcaFastApi : fcaGateWay).post(
        `${serviceEndpoints.recommendationEndPoints.updateRecommendationReviewStatus}/${id}/worker_update`,
        params
    );
export const deleteRecommendationReview = id => fcaGateWay.delete(`${serviceEndpoints.recommendationEndPoints.deleteRecommendationReview}/${id}`);
export const sendAllReviewNotifications = params =>
    fcaGateWay.post(`${serviceEndpoints.recommendationEndPoints.sendAllReviewNotifications}`, null, { params });
export const sendReviewNotification = (id, params) =>
    fcaGateWay.post(`${serviceEndpoints.recommendationEndPoints.sendReviewNotification}/${id}/send_notification`, params);
export const qaQcPassedUpdate = (id, params) =>
    fcaGateWay.patch(`${serviceEndpoints.recommendationEndPoints.updateQaQcPassed}/${id}/qa_approval`, params);
export const bulkQaUpdate = params => fcaFastApi.patch(`${serviceEndpoints.recommendationEndPoints.bulkQaUpdate}`, params);
export const getRecommendationReviewById = id =>
    (isEnabled("migrate_recommendations_crud") ? fcaFastApi : fcaGateWay).get(
        `${serviceEndpoints.recommendationEndPoints.getAllRecommendationReviews}/${id}`
    );
export const addReviewComment = params => fcaGateWay.post(`${serviceEndpoints.recommendationEndPoints.addReviewComment}`, params);
export const createAssetRecommendation = params => fcaGateWay.post(`${serviceEndpoints.recommendationEndPoints.createAssetRecommendation}`, params);
export const shiftCspYears = (id, params) =>
    fcaGateWay.patch(`${serviceEndpoints.recommendationEndPoints.shiftCspYears}/${id}/modify_funding`, params);
export const getSourceYears = params => fcaGateWay.post(`${serviceEndpoints.recommendationEndPoints.getSourceYears}`, params);
export const normalRecomGrouping = params =>
    fcaReportGateway.post(`${serviceEndpoints.recommendationEndPoints.normalRecomGrouping}`, params, { method: "POST", responseType: "blob" });
export const getAllMobileRecommendations = params =>
    fcaFastApi.get(`${serviceEndpoints.recommendationEndPoints.getAllMobileRecommendations}`, { params });
export const searchAndReplaceRecommendation = params => fcaGateWay.post(`${serviceEndpoints.recommendationEndPoints.searchAndReplace}`, params);
export const findRecommendationsBeforeReplace = params => fcaGateWay.post(`${serviceEndpoints.recommendationEndPoints.searchAndReplace}`, params);
export const getRecommendationsLog = params =>
    (isEnabled("migrate_recommendations_crud") ? fcaFastApi : fcaGateWay).get(`${serviceEndpoints.recommendationEndPoints.getRecommendationsLog}`, {
        params
    });
export const getRecommendationsLogDetails = params =>
    fcaGateWay.get(`${serviceEndpoints.recommendationEndPoints.getRecommendationsLogDetails}`, { params });
export const getRecommendationLogDropdown = params =>
    fcaGateWay.get(`${serviceEndpoints.recommendationEndPoints.getRecommendationLogDropdown}`, { params });
export const logExport = params =>
    fcaGateWay.get(`${serviceEndpoints.recommendationEndPoints.logExport}`, {
        method: "GET",
        responseType: "blob",
        params
    });
export const deleteExportHistory = (id, source = false) => {
    if (source === "asset_export_history") {
        return fcaReportGateway.delete(`${serviceEndpoints.assetEndPoints.exportHistoryDelete}/${id}/`);
    } else if (source === "files") {
        return fcaFastApi.delete(`${serviceEndpoints.assetEndPoints.filesDelete}/${id}`);
    } else return fcaReportGateway.delete(`${serviceEndpoints.recommendationEndPoints.exportHistoryDelete}/${id}/`);
};

export const sendRecomEmailNotification = (id, params) =>
    fcaFastApi.post(`/api/v1/recommendations/${id}${serviceEndpoints.recommendationEndPoints.sendRecomEmailNotification}`, params);

export const getGroupEditProgress = (id, params) => {
    return fcaFastApi.get(`${serviceEndpoints.recommendationEndPoints.getGroupEditProgress}${id}`, { params });
};
export const linkRecommendationsToCapitalRequest = (capitalRequestId, params) =>
    fcaFastApi.post(`${serviceEndpoints.capitalRequestLinkEndPoints.capitalRequests}/${capitalRequestId}/recommendations/link`, params);
export const unlinkRecommendationsFromCapitalRequest = (capitalRequestId, params) =>
    fcaFastApi.post(`${serviceEndpoints.capitalRequestLinkEndPoints.capitalRequests}/${capitalRequestId}/recommendations/unlink`, params);
